module.exports = "<div id=\"admin-container\">\n    <app-admin-header></app-admin-header>\n    <br /><br />\n    <div id=\"admin-body-container\">\n        <div class=\"routing-pannel\">\n            <app-admin-navigation></app-admin-navigation>\n        </div>\n        <div class=\"router-outlet\">\n            <router-outlet></router-outlet>\n        </div>\n    </div>\n</div>\n<!-- <app-footer></app-footer> -->\n"


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/admin.component.html
// module id = ../../../../../src/app/components/admin/admin.component.html
// module chunks = main